var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenStripes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 468,
    height: 122,
    viewBox: "0 0 468 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-58.5028 0L58.9943 138H10.4971L-107 0H-58.5028ZM38.4915 0L155.989 138H107.491L-10.0057 0H38.4915Z",
    fill: "#BAF4D3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M141.236 0L258.734 138H210.236L92.7393 0H141.236ZM238.231 0L355.728 138H307.231L189.734 0H238.231Z",
    fill: "#BAF4D3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M333.497 0L450.994 138H402.497L285 0H333.497ZM430.491 0L547.989 138H499.491L381.994 0H430.491Z",
    fill: "#BAF4D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenStripes);
export default __webpack_public_path__ + "static/media/green_stripes.2fbfe27d7314f11eeb6a9b945f6a480d.svg";
export { ForwardRef as ReactComponent };